"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIATIVES_SEARCH_SETTINGS = void 0;
exports.INITIATIVES_SEARCH_SETTINGS = {
    MIN_CHAR_FOR_SEARCH: 3,
    SEARCH_DELAY: 1000
};
//# sourceMappingURL=INITIATIVES_SEARCH_SETTINGS.js.map